var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "form",
        {
          attrs: { novalidate: "", disabled: _vm.disabled },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return (() => {}).apply(null, arguments)
            },
          },
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "", justify: "space-between" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        "max-width": "1200px",
                        flat: "",
                        color: "transparent",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        [
                          _c("FormHeader", {
                            attrs: {
                              loading: _vm.loading,
                              link: "page-blog-posts",
                              title: _vm.getTitle
                                ? `${_vm.getTitle} пост блога`
                                : `Создать пост блога`,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-tabs",
                        {
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        _vm._l(_vm.$options.tabs, function (tab) {
                          return _c("v-tab", { key: tab.value }, [
                            _vm._v(" " + _vm._s(tab.title) + " "),
                          ])
                        }),
                        1
                      ),
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        [
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "PageContent",
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-container",
                                        [
                                          _c("InputTitleSlug", {
                                            attrs: {
                                              "is-loading":
                                                _vm.loading || _vm.disabled,
                                              title: _vm.fields.title,
                                              "title-error":
                                                _vm.validationErrors.title,
                                              slug: _vm.fields.slug,
                                              "slug-error":
                                                _vm.validationErrors.slug,
                                              isSlugEnabled: !_vm.isNew,
                                            },
                                            on: {
                                              "change:title": function (
                                                $event
                                              ) {
                                                _vm.fields.title = $event
                                              },
                                              "change:slug": function ($event) {
                                                _vm.fields.slug = $event
                                              },
                                              "input:slug":
                                                _vm.$v.fields.slug.$touch,
                                            },
                                          }),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "span",
                                                    [
                                                      _vm._v("Анонс ("),
                                                      _c("TranslationIcon"),
                                                      _vm._v(")"),
                                                    ],
                                                    1
                                                  ),
                                                  _c("v-textarea", {
                                                    attrs: {
                                                      outlined: "",
                                                      disabled: _vm.disabled,
                                                      loading: _vm.loading,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.fields.announcement,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "announcement",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fields.announcement",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("MediaFilePicker", {
                                                    attrs: {
                                                      label: "Обложка",
                                                      multiple: false,
                                                      "file-type":
                                                        _vm.$options
                                                          .mediaTypesByKeys
                                                          .IMAGE,
                                                      value:
                                                        _vm.fields.coverImageId,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.fields.coverImageId =
                                                          $event
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("MediaFilePicker", {
                                                    attrs: {
                                                      label: "Миниатюра",
                                                      multiple: false,
                                                      "file-type":
                                                        _vm.$options
                                                          .mediaTypesByKeys
                                                          .IMAGE,
                                                      value:
                                                        _vm.fields.thumbnailId,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.fields.thumbnailId =
                                                          $event
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("SeoSettings", {
                                                    attrs: {
                                                      data: _vm.data,
                                                      loading:
                                                        _vm.loading ||
                                                        _vm.disabled,
                                                    },
                                                    on: {
                                                      "on-input-seo": function (
                                                        $event
                                                      ) {
                                                        _vm.fields =
                                                          Object.assign(
                                                            {},
                                                            _vm.fields,
                                                            $event
                                                          )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "PageContent",
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c("DynamicListWrapper", {
                                        attrs: {
                                          list: _vm.fields.widgets,
                                          "error-messages":
                                            _vm.mixValidationErrors,
                                          "available-items":
                                            _vm.$options.availableWidgets,
                                          "copy-clipboard":
                                            _vm.mixCopyListItemClipboard,
                                          options: _vm.$options.options,
                                        },
                                        on: {
                                          "list-sort": _vm.mixListItemsReassort,
                                          add: _vm.mixCreateListItemHandler,
                                          option: _vm.mixListItemOptionHandler,
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "item",
                                            fn: function ({ data }) {
                                              return [
                                                _c(data.item.type, {
                                                  tag: "component",
                                                  attrs: {
                                                    "list-item": data.item,
                                                    "error-messages":
                                                      _vm
                                                        .mixDynamicListValidationErrors[
                                                        data.itemIndex
                                                      ],
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.mixListItemChangeHandler(
                                                        $event,
                                                        data.itemIndex
                                                      )
                                                    },
                                                    "change-item": function (
                                                      $event
                                                    ) {
                                                      return _vm.mixListItemChangeItemHandler(
                                                        $event,
                                                        data.itemIndex
                                                      )
                                                    },
                                                    "remove-item": function (
                                                      $event
                                                    ) {
                                                      return _vm.mixListItemRemoveItemHandler(
                                                        $event,
                                                        data.itemIndex
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _vm.isNew
                    ? _c("ManageSidePanel", {
                        ref: "manageSidePanel",
                        attrs: {
                          isShowSortOrder: "",
                          "is-new": _vm.isNew,
                          "is-loading": _vm.loading,
                          "is-submit-disabled": _vm.disabled,
                          language: _vm.language,
                          translations: _vm.fields.translations,
                          sortOrder: _vm.fields.sortOrder,
                        },
                        on: {
                          "update-translations": function ($event) {
                            return Object.assign(
                              _vm.fields.translations,
                              $event
                            )
                          },
                          "language-update": function ($event) {
                            return _vm.$emit("language-update", $event)
                          },
                          cancel: function ($event) {
                            return _vm.$router.push({ name: "page-blog-posts" })
                          },
                          "update-sort-order": function ($event) {
                            _vm.fields.sortOrder = Number($event)
                          },
                          submit: _vm.submit,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "info-append",
                              fn: function () {
                                return [
                                  _c("StatusPicker", {
                                    attrs: {
                                      align: "center",
                                      cols: "12",
                                      title: "Статус:",
                                      disabled: _vm.disabled,
                                      loading: _vm.loading,
                                      status: _vm.fields.status,
                                    },
                                    on: {
                                      "status:change": function ($event) {
                                        _vm.fields.status = $event
                                      },
                                    },
                                  }),
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        align: "center",
                                        "no-gutters": "",
                                      },
                                    },
                                    [
                                      _c("v-col", { attrs: { cols: "7" } }, [
                                        _c("span", { staticClass: "mr-5" }, [
                                          _vm._v("Рекомендовано"),
                                        ]),
                                      ]),
                                      _c(
                                        "v-col",
                                        [
                                          _c("v-switch", {
                                            attrs: {
                                              inset: "",
                                              dense: "",
                                              disabled: _vm.disabled,
                                              loading: _vm.loading,
                                            },
                                            model: {
                                              value: _vm.fields.isRecommended,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "isRecommended",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "fields.isRecommended",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        align: "center",
                                        "no-gutters": "",
                                      },
                                    },
                                    [
                                      _c("v-col", { attrs: { cols: "7" } }, [
                                        _c("span", { staticClass: "mr-5" }, [
                                          _vm._v("Избранное"),
                                        ]),
                                      ]),
                                      _c(
                                        "v-col",
                                        [
                                          _c("v-switch", {
                                            attrs: {
                                              inset: "",
                                              dense: "",
                                              disabled: _vm.disabled,
                                              loading: _vm.loading,
                                            },
                                            model: {
                                              value: _vm.fields.isFeatured,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "isFeatured",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.isFeatured",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "body",
                              fn: function () {
                                return [
                                  _c(
                                    "v-card",
                                    { attrs: { flat: "" } },
                                    [
                                      !!_vm.blogCategories
                                        ? _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "v-card-subtitle",
                                                { staticClass: "grey--text" },
                                                [_vm._v("Категория блога")]
                                              ),
                                              _c("v-select", {
                                                attrs: {
                                                  outlined: "",
                                                  value: "4",
                                                  "item-value": "id",
                                                  "item-text": "title",
                                                  clearable: "",
                                                  items: _vm.blogCategories,
                                                  disabled: _vm.disabled,
                                                  loading: _vm.loading,
                                                  "error-messages":
                                                    _vm.validationErrors
                                                      .blogCategoryId,
                                                },
                                                model: {
                                                  value:
                                                    _vm.fields.blogCategoryId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.fields,
                                                      "blogCategoryId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "fields.blogCategoryId",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1428303847
                        ),
                      })
                    : _vm.data
                    ? _c("ManageSidePanel", {
                        ref: "manageSidePanel",
                        attrs: {
                          isShowSortOrder: "",
                          "is-new": !_vm.data.id,
                          "created-at": _vm.data.createdAt,
                          "updated-at": _vm.data.updatedAt,
                          "is-loading": _vm.loading,
                          "is-submit-disabled": _vm.disabled,
                          language: _vm.language,
                          translations: _vm.fields.translations,
                          "entity-id": _vm.data.id,
                          "entity-type": "blogPost",
                          sortOrder: _vm.fields.sortOrder,
                        },
                        on: {
                          delete: function ($event) {
                            return _vm.$emit("delete-blog-post")
                          },
                          cancel: function ($event) {
                            return _vm.$router.push({ name: "page-blog-posts" })
                          },
                          submit: _vm.submit,
                          "update-translations": function ($event) {
                            return Object.assign(
                              _vm.fields.translations,
                              $event
                            )
                          },
                          "language-update": function ($event) {
                            return _vm.$emit("language-update", $event)
                          },
                          "update-sort-order": function ($event) {
                            _vm.fields.sortOrder = Number($event)
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "info-append",
                            fn: function () {
                              return [
                                _c("StatusPicker", {
                                  attrs: {
                                    align: "center",
                                    cols: "12",
                                    "class-col": "pt-6",
                                    title: "Статус:",
                                    disabled: _vm.disabled,
                                    loading: _vm.loading,
                                    status: _vm.fields.status,
                                  },
                                  on: {
                                    "status:change": function ($event) {
                                      _vm.fields.status = $event
                                    },
                                  },
                                }),
                                !_vm.isNew
                                  ? _c(
                                      "v-row",
                                      { attrs: { align: "center" } },
                                      [
                                        _c("v-col", { attrs: { cols: "6" } }, [
                                          _c("span", [
                                            _vm._v("Посмотреть на сайте"),
                                          ]),
                                        ]),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "6" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  icon: "",
                                                  link: "",
                                                  color: "primary",
                                                  target: "_blank",
                                                  href: _vm.redirerectToWebPortal,
                                                  loading: _vm.loading,
                                                  disabled: _vm.disabled,
                                                },
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("mdi-web"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-row",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-col", { attrs: { cols: "6" } }, [
                                      _c("span", [_vm._v("Рекомендовано")]),
                                    ]),
                                    _c(
                                      "v-col",
                                      [
                                        _c("v-switch", {
                                          attrs: {
                                            inset: "",
                                            dense: "",
                                            disabled: _vm.disabled,
                                            loading: _vm.loading,
                                          },
                                          model: {
                                            value: _vm.fields.isRecommended,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.fields,
                                                "isRecommended",
                                                $$v
                                              )
                                            },
                                            expression: "fields.isRecommended",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-col", { attrs: { cols: "6" } }, [
                                      _c("span", [_vm._v("Избранное")]),
                                    ]),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c("v-switch", {
                                          attrs: {
                                            inset: "",
                                            dense: "",
                                            disabled: _vm.disabled,
                                            loading: _vm.loading,
                                          },
                                          model: {
                                            value: _vm.fields.isFeatured,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.fields,
                                                "isFeatured",
                                                $$v
                                              )
                                            },
                                            expression: "fields.isFeatured",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "body",
                            fn: function () {
                              return [
                                _c(
                                  "v-card",
                                  { attrs: { flat: "" } },
                                  [
                                    _c(
                                      "v-card-text",
                                      [
                                        _c(
                                          "v-card-subtitle",
                                          { staticClass: "grey--text" },
                                          [_vm._v("Категория блога")]
                                        ),
                                        _c("v-select", {
                                          attrs: {
                                            outlined: "",
                                            "item-value": "id",
                                            "item-text": "title",
                                            clearable: "",
                                            items: _vm.blogCategories,
                                            disabled: _vm.disabled,
                                            loading: _vm.loading,
                                            "error-messages":
                                              _vm.validationErrors
                                                .blogCategoryId,
                                          },
                                          model: {
                                            value: _vm.fields.blogCategoryId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.fields,
                                                "blogCategoryId",
                                                $$v
                                              )
                                            },
                                            expression: "fields.blogCategoryId",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }